<template>
  <MusicCard v-if="this.globalResources.portalType === this.portalType.Music" :item="item" />
  <GameCard v-else-if="this.globalResources.portalType === this.portalType.Game && (!skin || skin === 'put')" :item="item" />
  <GameCardBlueTheme v-else-if="this.globalResources.portalType === this.portalType.Game && ( skin
  === 'cloob' || skin === 'jabe')" :item="item" />
  <GameCardOrangeTheme v-else-if="this.globalResources.portalType === this.portalType.Game && skin
  === 'sunnyGames'" :item="item" />
</template>

<script>
import { mapGetters } from 'vuex'
import enums from '@/utilities/enums.js'
import GameCard from '@/components/GameCard.vue'
import GameCardBlueTheme from '@/components/GameCardBlueTheme.vue'
import GameCardOrangeTheme from '@/components/GameCardOrangeTheme.vue'
import MusicCard from '@/components/MusicCard.vue'

export default {
  name: 'ProductCard',
  components: {
    GameCard,
    GameCardBlueTheme,
    GameCardOrangeTheme,
    MusicCard
  },
  mixins: [enums],
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data(){
    return{
      skin: null
    }
  },
  computed: {
    ...mapGetters({
      portalConfigurations: 'tenantDesign/config'
    })
  },
  created(){
    this.skin = this.portalConfigurations.general.Skin
  }
}
</script>
